import getApi from '../../api'

export const deleteTag = (id: string) => getApi().delete<null>(`/tags/${id}`)
